module.exports = __webpack_public_path__ + "static/media/draw-connected.23fe2823.svg";